import { BlackOut } from '../objects/blackOut';
import { Column } from '../objects/column';
import { EarlyBookingRule } from '../objects/earlyBookingRule';
import { ExtraPrice } from '../objects/extraPrice';
import { Fact } from '../objects/fact';
import { IntervalAgeOffer } from '../objects/intervalAgeOffer';
import { MinimalStay } from '../objects/minimalStay';
import { RoomBedding } from '../objects/roomBedding';
import { RoomPrice } from '../objects/roomPrice';
import { RoomPricePeriod } from '../objects/roomPricePeriod';
import { RoomStayPeriod } from '../objects/roomStayPeriod';
import { Rule } from '../objects/rule';
import { YieldRule } from '../objects/yieldRule';
import { StayDuration } from '../objects/stayDuration';

export const EMPTY_FACTS: Fact[] = [
    // {codename: 'beach_directly', value_bool: false, value_int: null},
    // {codename: 'beach_parasols', value_bool: false, value_int: null},
    // {codename: 'beach_pebbles', value_bool: false, value_int: null},
    // {codename: 'beach_rocky', value_bool: false, value_int: null},
    // {codename: 'beach_sandy', value_bool: false, value_int: null},
    // {codename: 'beach_separatedbyroad', value_bool: false, value_int: null},
    { codename: 'facility_aircon', value_bool: false, value_int: null },
    { codename: 'facility_babysitter', value_bool: false, value_int: null },
    { codename: 'facility_baggageroom', value_bool: false, value_int: null },
    { codename: 'facility_bars', value_bool: false, value_int: null },
    { codename: 'facility_bicyclecellar', value_bool: false, value_int: null },
    { codename: 'facility_bicyclehire', value_bool: false, value_int: null },
    { codename: 'facility_bilingualstaff', value_bool: false, value_int: null },
    { codename: 'facility_businesscenter', value_bool: false, value_int: null },
    { codename: 'facility_cafe', value_bool: false, value_int: null },
    { codename: 'facility_carpark', value_bool: false, value_int: null },
    { codename: 'facility_casino', value_bool: false, value_int: null },
    { codename: 'facility_checkin24', value_bool: false, value_int: null },
    { codename: 'facility_childrenspool', value_bool: false, value_int: null },
    { codename: 'facility_cloakroom', value_bool: false, value_int: null },
    { codename: 'facility_computer', value_bool: false, value_int: null },
    { codename: 'facility_conferenceroom', value_bool: false, value_int: null },
    {
        codename: 'facility_conferencerooms',
        value_bool: false,
        value_int: null
    },
    { codename: 'facility_disco', value_bool: false, value_int: null },
    { codename: 'facility_electriciron', value_bool: false, value_int: null },
    { codename: 'facility_evelators', value_bool: false, value_int: null },
    { codename: 'facility_footboy', value_bool: false, value_int: null },
    { codename: 'facility_foyer', value_bool: false, value_int: null },
    { codename: 'facility_gamesroom', value_bool: false, value_int: null },
    { codename: 'facility_garage', value_bool: false, value_int: null },
    { codename: 'facility_garden', value_bool: false, value_int: null },
    { codename: 'facility_hairdresser', value_bool: false, value_int: null },
    { codename: 'facility_internet', value_bool: false, value_int: null },
    { codename: 'facility_kiosk', value_bool: false, value_int: null },
    { codename: 'facility_laundry', value_bool: false, value_int: null },
    { codename: 'facility_laundryservice', value_bool: false, value_int: null },
    { codename: 'facility_lifts', value_bool: false, value_int: null },
    { codename: 'facility_medicalservice', value_bool: false, value_int: null },
    { codename: 'facility_miniclub', value_bool: false, value_int: null },
    { codename: 'facility_mobilephonenet', value_bool: false, value_int: null },
    { codename: 'facility_moneyexchange', value_bool: false, value_int: null },
    { codename: 'facility_newsstand', value_bool: false, value_int: null },
    { codename: 'facility_outdoorpool', value_bool: false, value_int: null },
    { codename: 'facility_parasols', value_bool: false, value_int: null },
    { codename: 'facility_pets', value_bool: false, value_int: null },
    { codename: 'facility_playground', value_bool: false, value_int: null },
    { codename: 'facility_poolbar', value_bool: false, value_int: null },
    { codename: 'facility_pub', value_bool: false, value_int: null },
    { codename: 'facility_reception', value_bool: false, value_int: null },
    { codename: 'facility_reception24', value_bool: false, value_int: null },
    { codename: 'facility_receptionarea', value_bool: false, value_int: null },
    { codename: 'facility_restaurant', value_bool: false, value_int: null },
    {
        codename: 'facility_restaurant_smokingarea',
        value_bool: false,
        value_int: null
    },
    { codename: 'facility_restaurants', value_bool: false, value_int: null },
    {
        codename: 'facility_restaurants_aircon',
        value_bool: false,
        value_int: null
    },
    {
        codename: 'facility_restaurants_highchair',
        value_bool: false,
        value_int: null
    },
    {
        codename: 'facility_restaurants_nosmokingarea',
        value_bool: false,
        value_int: null
    },
    { codename: 'facility_roomservice', value_bool: false, value_int: null },
    { codename: 'facility_safe', value_bool: false, value_int: null },
    { codename: 'facility_shops', value_bool: false, value_int: null },
    { codename: 'facility_shower', value_bool: false, value_int: null },
    { codename: 'facility_smoking', value_bool: false, value_int: null },
    { codename: 'facility_solarium', value_bool: false, value_int: null },
    { codename: 'facility_supermarket', value_bool: false, value_int: null },
    { codename: 'facility_terrace', value_bool: false, value_int: null },
    { codename: 'facility_theatre', value_bool: false, value_int: null },
    { codename: 'facility_tourdesk', value_bool: false, value_int: null },
    { codename: 'facility_towels', value_bool: false, value_int: null },
    { codename: 'facility_transfert', value_bool: false, value_int: null },
    { codename: 'facility_tvroom', value_bool: false, value_int: null },
    { codename: 'facility_washing', value_bool: false, value_int: null },
    { codename: 'facility_wifi', value_bool: false, value_int: null },
    { codename: 'facility_wlan', value_bool: false, value_int: null },
    { codename: 'hoteltype_airporthotel', value_bool: false, value_int: null },
    {
        codename: 'hoteltype_apartmenthotel',
        value_bool: false,
        value_int: null
    },
    { codename: 'hoteltype_beachhotel', value_bool: false, value_int: null },
    {
        codename: 'hoteltype_bungalowcomplex',
        value_bool: false,
        value_int: null
    },
    { codename: 'hoteltype_business', value_bool: false, value_int: null },
    { codename: 'hoteltype_casinoresort', value_bool: false, value_int: null },
    { codename: 'hoteltype_cityhotel', value_bool: false, value_int: null },
    { codename: 'hoteltype_clubresort', value_bool: false, value_int: null },
    {
        codename: 'hoteltype_conferencehotel',
        value_bool: false,
        value_int: null
    },
    { codename: 'hoteltype_ecohotel', value_bool: false, value_int: null },
    { codename: 'hoteltype_family', value_bool: false, value_int: null },
    { codename: 'hoteltype_finca', value_bool: false, value_int: null },
    { codename: 'hoteltype_golfhotel', value_bool: false, value_int: null },
    { codename: 'hoteltype_guesthouse', value_bool: false, value_int: null },
    { codename: 'hoteltype_historic', value_bool: false, value_int: null },
    { codename: 'hoteltype_hoteldecharme', value_bool: false, value_int: null },
    { codename: 'hoteltype_mountainhotel', value_bool: false, value_int: null },
    { codename: 'hoteltype_mountainhut', value_bool: false, value_int: null },
    { codename: 'hoteltype_ruralhouse', value_bool: false, value_int: null },
    { codename: 'hoteltype_skihotel', value_bool: false, value_int: null },
    { codename: 'hoteltype_spacomplex', value_bool: false, value_int: null },
    { codename: 'hoteltype_village', value_bool: false, value_int: null },
    { codename: 'hoteltype_youthhostel', value_bool: false, value_int: null },
    { codename: 'located_on_main_road', value_bool: false, value_int: null },
    { codename: 'meals_allinclusive', value_bool: false, value_int: null },
    { codename: 'meals_bedandbreakfast', value_bool: false, value_int: null },
    { codename: 'meals_breakfast', value_bool: false, value_int: null },
    { codename: 'meals_breakfastbuffet', value_bool: false, value_int: null },
    {
        codename: 'meals_breakfastcontinental',
        value_bool: false,
        value_int: null
    },
    { codename: 'meals_breakfastserved', value_bool: false, value_int: null },
    { codename: 'meals_dinner', value_bool: false, value_int: null },
    { codename: 'meals_dinnerbuffet', value_bool: false, value_int: null },
    { codename: 'meals_dinnercarte', value_bool: false, value_int: null },
    { codename: 'meals_dinnerchoice', value_bool: false, value_int: null },
    { codename: 'meals_drinksincluded', value_bool: false, value_int: null },
    { codename: 'meals_fullboard', value_bool: false, value_int: null },
    { codename: 'meals_halfboard', value_bool: false, value_int: null },
    { codename: 'meals_lunch', value_bool: false, value_int: null },
    { codename: 'meals_lunchbuffet', value_bool: false, value_int: null },
    { codename: 'meals_lunchcarte', value_bool: false, value_int: null },
    { codename: 'meals_lunchchoice', value_bool: false, value_int: null },
    { codename: 'meals_roomservice', value_bool: false, value_int: null },
    { codename: 'meals_specialdiet', value_bool: false, value_int: null },
    { codename: 'meals_specialoffers', value_bool: false, value_int: null },
    { codename: 'payment_amex', value_bool: false, value_int: null },
    { codename: 'payment_diners', value_bool: false, value_int: null },
    { codename: 'payment_ec', value_bool: false, value_int: null },
    { codename: 'payment_jcb', value_bool: false, value_int: null },
    { codename: 'payment_master', value_bool: false, value_int: null },
    { codename: 'payment_visa', value_bool: false, value_int: null },
    { codename: 'room_aircon', value_bool: false, value_int: null },
    { codename: 'room_aircon_indiv', value_bool: false, value_int: null },
    { codename: 'room_balcony', value_bool: false, value_int: null },
    { codename: 'room_bath', value_bool: false, value_int: null },
    { codename: 'room_bathroom', value_bool: false, value_int: null },
    { codename: 'room_bathtub', value_bool: false, value_int: null },
    { codename: 'room_bidet', value_bool: false, value_int: null },
    { codename: 'room_carpeted', value_bool: false, value_int: null },
    { codename: 'room_centralheating', value_bool: false, value_int: null },
    { codename: 'room_childrensbed', value_bool: false, value_int: null },
    { codename: 'room_directdialtel', value_bool: false, value_int: null },
    { codename: 'room_doublebed', value_bool: false, value_int: null },
    { codename: 'room_electriciron', value_bool: false, value_int: null },
    { codename: 'room_finalcleaning', value_bool: false, value_int: null },
    { codename: 'room_fridge', value_bool: false, value_int: null },
    { codename: 'room_hairdryer', value_bool: false, value_int: null },
    { codename: 'room_heating', value_bool: false, value_int: null },
    { codename: 'room_hifi', value_bool: false, value_int: null },
    { codename: 'room_individualheating', value_bool: false, value_int: null },
    { codename: 'room_internet', value_bool: false, value_int: null },
    { codename: 'room_kingsizedbeds', value_bool: false, value_int: null },
    { codename: 'room_kitchen', value_bool: false, value_int: null },
    { codename: 'room_kitchenette', value_bool: false, value_int: null },
    { codename: 'room_lounge', value_bool: false, value_int: null },
    { codename: 'room_microwave', value_bool: false, value_int: null },
    { codename: 'room_minibar', value_bool: false, value_int: null },
    { codename: 'room_nonsmoking', value_bool: false, value_int: null },
    { codename: 'room_oven', value_bool: false, value_int: null },
    { codename: 'room_phone', value_bool: false, value_int: null },
    { codename: 'room_radio', value_bool: false, value_int: null },
    { codename: 'room_safe', value_bool: false, value_int: null },
    { codename: 'room_satcabletv', value_bool: false, value_int: null },
    { codename: 'room_shower', value_bool: false, value_int: null },
    { codename: 'room_slippers', value_bool: false, value_int: null },
    { codename: 'room_tea_coffee', value_bool: false, value_int: null },
    { codename: 'room_tiled', value_bool: false, value_int: null },
    { codename: 'room_tv', value_bool: false, value_int: null },
    { codename: 'room_washingmachine', value_bool: false, value_int: null },
    { codename: 'room_wifi', value_bool: false, value_int: null },
    { codename: 'spa_hammam', value_bool: false, value_int: null },
    { codename: 'spa_spa', value_bool: false, value_int: null },
    { codename: 'sports_aerobics', value_bool: false, value_int: null },
    { codename: 'sports_archery', value_bool: false, value_int: null },
    { codename: 'sports_badminton', value_bool: false, value_int: null },
    { codename: 'sports_bananaboat', value_bool: false, value_int: null },
    { codename: 'sports_basketball', value_bool: false, value_int: null },
    { codename: 'sports_beachvolleyball', value_bool: false, value_int: null },
    { codename: 'sports_billiards', value_bool: false, value_int: null },
    { codename: 'sports_boccia', value_bool: false, value_int: null },
    { codename: 'sports_bowling', value_bool: false, value_int: null },
    { codename: 'sports_canoe', value_bool: false, value_int: null },
    { codename: 'sports_catamaran', value_bool: false, value_int: null },
    { codename: 'sports_darts', value_bool: false, value_int: null },
    { codename: 'sports_entertainment', value_bool: false, value_int: null },
    {
        codename: 'sports_entertainment_kids',
        value_bool: false,
        value_int: null
    },
    { codename: 'sports_golf', value_bool: false, value_int: null },
    { codename: 'sports_gym', value_bool: false, value_int: null },
    { codename: 'sports_gymnastics', value_bool: false, value_int: null },
    { codename: 'sports_horseriding', value_bool: false, value_int: null },
    { codename: 'sports_jacuzzi', value_bool: false, value_int: null },
    { codename: 'sports_jetski', value_bool: false, value_int: null },
    { codename: 'sports_massage', value_bool: false, value_int: null },
    { codename: 'sports_minigolf', value_bool: false, value_int: null },
    { codename: 'sports_motorboat', value_bool: false, value_int: null },
    { codename: 'sports_mtb', value_bool: false, value_int: null },
    { codename: 'sports_parasols', value_bool: false, value_int: null },
    { codename: 'sports_pedalo', value_bool: false, value_int: null },
    { codename: 'sports_pool_indoor', value_bool: false, value_int: null },
    { codename: 'sports_poolbar', value_bool: false, value_int: null },
    { codename: 'sports_poolchildrens', value_bool: false, value_int: null },
    { codename: 'sports_poolfreshwater', value_bool: false, value_int: null },
    { codename: 'sports_poolheated', value_bool: false, value_int: null },
    { codename: 'sports_pooloutdoor', value_bool: false, value_int: null },
    { codename: 'sports_poolsaltwater', value_bool: false, value_int: null },
    { codename: 'sports_sailing', value_bool: false, value_int: null },
    { codename: 'sports_sauna', value_bool: false, value_int: null },
    { codename: 'sports_scuba', value_bool: false, value_int: null },
    { codename: 'sports_special_spa_pack', value_bool: false, value_int: null },
    { codename: 'sports_squash', value_bool: false, value_int: null },
    { codename: 'sports_steambath', value_bool: false, value_int: null },
    {
        codename: 'sports_sunbathing_terrace',
        value_bool: false,
        value_int: null
    },
    { codename: 'sports_sunloungers', value_bool: false, value_int: null },
    { codename: 'sports_surfing', value_bool: false, value_int: null },
    { codename: 'sports_tabletennis', value_bool: false, value_int: null },
    { codename: 'sports_tanning_studio', value_bool: false, value_int: null },
    { codename: 'sports_tennis', value_bool: false, value_int: null },
    { codename: 'sports_wateraerobics', value_bool: false, value_int: null },
    { codename: 'sports_waterskiing', value_bool: false, value_int: null },
    { codename: 'sports_windsurfing', value_bool: false, value_int: null }
];

export const EMPTY_INTERVAL_AGE_OFFERS: IntervalAgeOffer[] = [{ min_age: '', min_age_error: '', max_age: '', max_age_error:'', price: '', price_error:'' }];
export const EMPTY_EXTRA_PRICE: ExtraPrice = {
    end_date: null,
    end_date_error: '',
    interval_age_prices: EMPTY_INTERVAL_AGE_OFFERS,
    price: '',
    price_error: '',
    price_adult: '',
    price_adult_error: '',
    price_child: '',
    price_child_error: '',
    price_infant: '',
    price_infant_error: '',
    price_teen: '',
    price_teen_error: '',
    price_type: 'FIX',
    start_date: null,
    start_date_error: ''
};

export const EMPTY_CANCELLATION_CONDITION: Rule = {
    nb_days: 0,
    price_type: 'FIX',
    value: 0,
    cancellation_type: 0
};

export const EMPTY_EARLY_BOOKING_CONDITION: EarlyBookingRule = {
    days: '',
    days_error: '',
    deduction: '',
    deduction_error: '',
    deduction_type: 'FIX',
    max_date: null,
    max_date_error: '',
    type: 'DAYS'
};

export const EMPTY_YELD_RULE: YieldRule = {
    amount: '',
    amount_type: 'PER',
    days: 0,
    type: 0
};

export const EMPTY_ROOM_MIN_STAY_PERIOD: RoomStayPeriod = {
    nights: 0,
    nights_error: '',
    end_date: null,
    end_date_error: '',
    start_date: null,
    start_date_error: ''
};

export const EMPTY_ROOM_BEDDING: RoomBedding = {
    simple_bed: 0,
    queen_size: 0,
    king_size: 0,
    twin_bed: 0,
    double_bed: 0,
    sofa_bed: 0,
    baby_bed: 0,
    rollaway_bed: 0,
    bunk_bed: 0,
    futon: 0
};

export const EMPTY_ROOM_PRICE_PERIOD: RoomPricePeriod = {
    start_date: null,
    start_date_error: '',
    end_date: null,
    end_date_error: '',
    days: [0, 1, 2, 3, 4, 5, 6],
    days_error: ''
};

export const EMPTY_ROOM_BLACK_OUT: BlackOut = {
    end_date: null,
    end_date_error: '',
    start_date: null,
    start_date_error: ''
};

export const EMPTY_ROOM_PRICE: RoomPrice = {
    periods: [{ ...EMPTY_ROOM_PRICE_PERIOD }],
    stock: 0,
    stock_error: '',
    restitution_days: 0,
    // purchase
    single: 0,
    single_price_error: '',
    double: 0,
    triple: 0,
    quad: 0,
    mono: 0,
    extra_adult: 0,
    extra_infant: 0,
    extra_baby: 0,
    extra_teen: 0,
    price_adult: 0,
    price_teen: 0,
    price_child: 0,
    price_baby: 0,

    // selling
    selling_single: 0,
    selling_single_error: '',
    selling_double: 0,
    selling_double_error: '',
    selling_triple: 0,
    selling_triple_error: '',
    selling_quad: 0,
    selling_quad_error: '',
    selling_mono: 0,
    selling_mono_error: '',
    selling_extra_adult: 0,
    selling_extra_adult_error: '',
    selling_extra_infant: 0,
    selling_extra_infant_error: '',
    selling_extra_baby: 0,
    selling_extra_baby_error: '',
    selling_extra_teen: 0,
    selling_extra_teen_error: '',
    selling_price_adult: 0,
    selling_price_adult_error: '',
    selling_price_teen: 0,
    selling_price_teen_error: '',
    selling_price_child: 0,
    selling_price_child_error: '',
    selling_price_baby: 0,
    selling_price_baby_error: '',

    // com_
    com_single: 0,
    com_single_price_error: '',
    com_double: 0,
    com_triple: 0,
    com_quad: 0,
    com_mono: 0,
    com_extra_adult: 0,
    com_extra_infant: 0,
    com_extra_baby: 0,
    com_extra_teen: 0,
    com_price_adult: 0,
    com_price_teen: 0,
    com_price_child: 0,
    com_price_baby: 0,


    // markup
    markup_single: 0,
    markup_single_price_error: '',
    markup_double: 0,
    markup_triple: 0,
    markup_quad: 0,
    markup_mono: 0,
    markup_extra_adult: 0,
    markup_extra_infant: 0,
    markup_extra_baby: 0,
    markup_extra_teen: 0,
    markup_price_adult: 0,
    markup_price_teen: 0,
    markup_price_child: 0,
    markup_price_baby: 0,

    mono_adult: 'MNPARENT_NORMAL',
    mono_child: 'CHILD_AS_ADT_ZERO'
};

export const EMPTY_COLUMNS: Column[] = [
    {
        label: 'name',
        field_name: 'NAME',
        checked: true,
        order_by: 'name',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'reviewed-by-marketing',
        field_name: 'LOCK',
        checked: true,
        order_by: 'lock',
        fixed_width: true,
        last_updated: false
    },
    {
        label: 'website-publication',
        field_name: 'PUBLISHED_ON_WEB',
        checked: true,
        order_by: 'publish_on_web ',
        fixed_width: true,
        last_updated: false
    },
    {
        label: 'client-hotel-identifier',
        field_name: 'CLIENT_HOTEL_IDENTIFIER',
        checked: false,
        order_by: 'client_hotel_identifier',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'address',
        field_name: 'ADDRESS',
        checked: false,
        order_by: 'street',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'destination',
        field_name: 'DESTINATION',
        checked: true,
        order_by: 'destination_name',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'country',
        field_name: 'COUNTRY',
        checked: true,
        order_by: 'country',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'hotel-chain',
        field_name: 'CHAIN',
        checked: true,
        order_by: 'chain__name',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'online-to',
        field_name: 'VISIBILITY',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false
    },
    {
        label: 'online-agency',
        field_name: 'AGENCY_VISIBILITY',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false
    },
    {
        label: 'tags',
        field_name: 'TAGS',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false
    },
    {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    },
    {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: false,
        last_updated: false
    },
    {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    },
    {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: false,
        last_updated: false
    }
];

export const EMPTY_MINIMAL_STAY: MinimalStay = {
    start_date: null,
    start_date_error: '',
    end_date: null,
    end_date_error: '',
    nb_days: '',
    nb_days_error: '',
};

export const EMPTY_STAY_DURATION: StayDuration = {
    start_date: null,
    end_date: null,
    nb_days: '',
    nb_max_days: '',
};